import '../css/index.scss';
import $ from 'jquery';


/**js**/
'use strict';

let windowWidth = $(window).width();
let windowHeight = $(window).height();
//let adjust = null;
const BREAKPOINT_SP = 768;


const setup = () => {

  // UA
  const _ua = (function(u){
    return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1) 
        || u.indexOf("ipad") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
        || u.indexOf("kindle") != -1
        || u.indexOf("silk") != -1
        || u.indexOf("playbook") != -1,
      Mobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
        || u.indexOf("iphone") != -1
        || u.indexOf("ipod") != -1
        || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
        || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
        || u.indexOf("blackberry") != -1
    }
  })(window.navigator.userAgent.toLowerCase());
  
  if(!_ua.Mobile && !_ua.Tablet){
  }

  // アンカーリンクを取得
  // const anchors = document.querySelectorAll('.nav-item-link');
  // anchors.forEach(anchor => {
  //   anchor.addEventListener('click', function (e) {
  //     // urlを変更しないようにする
  //     e.preventDefault();
  //     // スクロール
  //     // lenis.scrollTo( '#' + this.getAttribute('data-target'))
  //   });
  // });

};


window.addEventListener('load',function(){

  let vw = window.innerWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // if (windowWidth <= BREAKPOINT_SP) {
  //   adjust = windowHeight * .25;
  // } else {
  //   adjust = windowHeight * .15;
  // }

  // progressbar.js
  var ProgressBar = require('progressbar.js');
  var line = new ProgressBar.Line('#loading .progressBar', {
    strokeWidth: 1,
    easing: 'easeInOut',
    duration: 1400,
    color: '#000',
    trailColor: '#F5F5F5',
    trailWidth: 1,
    svgStyle: {width: '100.0%', height: '20.0%'},
  });

  line.animate(1.0, function () {

    // Loading fadeout
    $("#loading").delay(400).fadeOut(800);

    setup();

    const body = document.querySelector( 'body' );
    setTimeout(() => {
      body.classList.add('opening');
      setTimeout(() => {
        body.classList.add('complete');
        body.classList.remove('opening');
      },2400);
    },1000);

  });

});


// splidejs
document.addEventListener('DOMContentLoaded',function() {

  // collection
  const sliders = document.querySelectorAll('#collection-carousel');
  
  for (const slider of sliders) {

    const splide = new Splide(slider, {
      speed       : 1600,
      padding     : '28.5%',
      updateOnMove: true,
      type        : 'loop',
      perMove     : 1,
      focus       : 'center',
      clones      : 3,
      cloneStatus : true,
      autoHeight  : true,
      arrows      : true,
      arrowPath   : 'M10.945 .5 9.554 1.892 27.662 20 9.554 38.108 10.945 39.5 30.446 20.001 10.945 .5',
      flickMaxPages : 1,
      waitForTransition : false,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
      breakpoints: {
        768: {
          speed   : 2400,
          padding : '24.0%',
        }
      }
    });
    const thumbnails = new Splide( '#collection-carousel-sub', {
      speed       : 1600,
      type        : 'fade',
      perMove     : 1,
      arrows      : false,
      cover       : true,
      pagination  : false,
      dragMinThreshold: {
        mouse: 4,
        touch: 10,
      },
    });

    splide.on('ready', () => {
      slider.classList.add('is-ready');
    });

    // splide.on('moved', (newIndex) => {
    //   var slide = splide.Components.Slides.getAt(newIndex).slide;
    //   var virtualPagePath = slide.getAttribute('data-wwd-content');
    //   //var virtualPagePath = `#pvcount_${splide.index - 1}`;

    //   if (virtualPagePath) {
    //     sendVirtualPageView(virtualPagePath);
    //   }
    // });

    splide.sync( thumbnails );
    splide.mount();
    thumbnails.mount();

  }

  // miles
  const sliders02 = document.querySelectorAll('#photo-carousel');
  for (const slider02 of sliders02) {
    const splide02 = new Splide(slider02, {
      type      : 'fade',
      rewind    : true,
      pagination  : false,
      speed     : 1600,
      padding   : '10.8rem',
      arrows    : true,
      arrowPath : 'M10.945 .5 9.554 1.892 27.662 20 9.554 38.108 10.945 39.5 30.446 20.001 10.945 .5',
      breakpoints: {
        768: {
          padding : '8.67%',
        }
      }
    });

    splide02.on('mounted', () => {
      const slides = splide02.Components.Slides.get();
      const lastSlide = slides[slides.length - 1].slide;
      lastSlide.classList.add('is-before');

      // 初期表示時の矢印画像更新
      updateArrowThumbnails(splide02, splide02.index);
    });

    splide02.on('active', (i) => {
      const slides = splide02.Components.Slides.get();
      const firstSlide = slides[0].slide;
      const lastSlide = slides[slides.length - 1].slide;

      // console.log(i.index);
      // console.log(slides[slides.length - 1]);
      // console.log(slides[slides.length - 0]);
      
      if ( i.index === 0 ){
        firstSlide.classList.remove('is-after');
        lastSlide.classList.add('is-before');
        // console.log(lastSlide);
      } else if ( i.index === slides[slides.length - 1].index){
        lastSlide.classList.remove('is-before');
        firstSlide.classList.add('is-after');
        // console.log(firstSlide);
      } else {
        firstSlide.classList.remove('is-after');
        lastSlide.classList.remove('is-before');
      }

    });

    splide02.on('moved', (newIndex) => {
      updateArrowThumbnails(splide02, newIndex);
    });

    splide02.mount();
  }
});

// 前後の矢印にpictureを追加する関数
function updateArrowThumbnails(splideInstance, currentIndex) {
  const slides = splideInstance.Components.Slides.get();

  const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
  const nextIndex = (currentIndex + 1) % slides.length;

  const prevSlide = slides[prevIndex].slide;
  const nextSlide = slides[nextIndex].slide;

  const prevPicture = prevSlide.querySelector('picture');
  const nextPicture = nextSlide.querySelector('picture');

  const prevArrow = document.querySelector('.splide__arrow--prev');
  const nextArrow = document.querySelector('.splide__arrow--next');

  // pictureだけ削除（SVGは残す）
  prevArrow.querySelector('picture')?.remove();
  nextArrow.querySelector('picture')?.remove();

  if (prevPicture) {
    const clonePrev = prevPicture.cloneNode(true);
    prevArrow.appendChild(clonePrev);
  }

  if (nextPicture) {
    const cloneNext = nextPicture.cloneNode(true);
    nextArrow.appendChild(cloneNext);
  }
}

// PV送信用（ユニバーサルアナリティクス or GA4 対応） 
function sendVirtualPageView(path) {
  if (window.gtag) {
    // GA4
    gtag('event', 'page_view', {
      page_path: path,
    });
  } else if (window.ga) {
    // Universal Analytics
    ga('set', 'page', path);
    ga('send', 'pageview');
  } else if (window._gaq) {
    // 古いバージョン対応
    _gaq.push(['_set', 'page', path]);
    _gaq.push(['_trackPageview']);
  }

  console.log('Virtual pageview sent:', path);
}


// resize
var resizeTimer;
var interval = 1000;

window.addEventListener('resize',function() {

  //location.reload(true); // 再読み込み

  if (resizeTimer !== false) {
    clearTimeout(resizeTimer);
  }

  resizeTimer = setTimeout(function() {
    windowHeight = $(window).height();

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

  }, interval);

});


$(function(){

  // drawer-nav

  const gNaviButton = $('.js-drawer-button');
  const gNavi = $('.js-drawer-nav');
  const gNaviAnchor = $('.js-drawer-nav .nav-item-link');

  gNaviButton.on('click', function(){
    gNaviButton.toggleClass('--active');
    gNavi.toggleClass('--active');
  });

  gNaviAnchor.on('click', function(){
    gNaviButton.toggleClass('--active');
    gNavi.toggleClass('--active');
  });


  // info-about

  const aboutInfo = $('.js-info-about');
  const aboutInfoButton = $('.js-info-about-button');

  aboutInfoButton.on('click', function(){
    aboutInfo.toggleClass('--active');
  });


  // intro-navi

  const introNavi = $('.js-intro-nav');
  const introNaviButton = $('.js-intro-button .button-toggle');
  const introNaviCloseButton = $('.js-intro-nav .button-toggle');

  introNaviButton.on('click', function(){
    introNavi.toggleClass('--active');
  });

  introNaviCloseButton.on('click', function(){
    introNavi.toggleClass('--active');
  });


});

$(function() {
  const target = 'data-hover-animation-target',
        text = document.querySelectorAll(`[${target}]`);

  text.forEach(link => {

    const letters = link.textContent.split('');
    link.textContent = '';
    const spanOrigin = document.createElement('span');
    spanOrigin.setAttribute('data-hover-animation-origin', '');

    letters.forEach((letter,i) =>{
      const delay = i / 32;
      i += 1;

      const letterOut = document.createElement("span");
      letterOut.textContent = letter;
      letterOut.style.transitionDelay = `${delay}s`;

      spanOrigin.append(letterOut);
      link.append(spanOrigin);
    })

    const spanClone = document.createElement('span');
    spanClone.setAttribute('data-hover-animation-clone', '');

    letters.forEach((letter,i) =>{
      const delay = i / 30;
      i += 1;

      let letterIn = document.createElement("span");
      letterIn.textContent = letter;
      letterIn.style.transitionDelay = `${delay}s`;

      spanClone.append(letterIn);
      link.append(spanClone);
    })

  })
});



/*----------------------------------------------------------
video
----------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".video");
  let currentSize = '';

  function updateVideoSource(video, baseSrc) {

    const suffix = window.innerWidth <= 768 ? "_sp" : "_pc";
    const sourceMP4 = document.createElement("source");

    sourceMP4.setAttribute("src", baseSrc + suffix + ".mp4");
    sourceMP4.setAttribute("type", "video/mp4");

    video.innerHTML = "";
    video.appendChild(sourceMP4);
  }

  videos.forEach((video) => {
    const baseSrc = video.getAttribute("data-src");
    updateVideoSource(video, baseSrc);
  });

  // window.addEventListener("resize", function () {
  //   const newSize = window.innerWidth;
  //   if (currentSize !== newSize) {
  //     currentSize = newSize;
  //     videos.forEach((video) => {
  //       const baseSrc = video.getAttribute("data-src");
  //       updateVideoSource(video, baseSrc);
  //     });
  //   }
  // });

});


/*----------------------------------------------------------
Google Analytics
----------------------------------------------------------*/

$(function() {

  var url = location.href;
  var pvData = [];

  $('[data-preview]').each(function() {
    var position = $(this).offset().top;
    var data = $(this).attr('data-preview');
    pvData.push({position: position, data: data});
    //console.log(pvData[0].position);
  });


  $(window).on('orientationchange scroll load resize', function(){
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();

    $('[data-preview]').not('.processed').each(function() {
      var position = $(this).offset().top - windowHeight * .5;
      var data = $(this).attr('data-preview');
      if (scrollPosition > position) {
        $(this).addClass('processed');
        GAsend(data);
      }
    });
  });

  function GAsend(data){
    var PATH = '#' + data;
    ga('set', 'location', url + PATH);
    ga('send', 'pageview');
    //console.log('GAsend: ' + url + PATH );
  }

});